var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvviso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "20px",
    viewBox: "0 0 23 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avviso") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avviso"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_play_1939965-copy-2",
    transform: "translate(11.500000, 10.500000) rotate(-90.000000) translate(-11.500000, -10.500000) translate(2.000000, -1.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6020951,8.45923266 L4.69255071,-1.18620539 C3.33571666,-2.01018753 1.5,-1.11350108 1.5,0.364819826 L1.5,19.6314611 C1.5,21.1340168 3.33571666,22.0064685 4.69255071,21.1824864 L20.6020951,11.5370483 C21.7993016,10.83424 21.7993016,9.18627573 20.6020951,8.45923266 Z",
    id: "Shape",
    fill: "#F8E71C",
    fillRule: "nonzero",
    transform: "translate(11.500000, 10.000000) rotate(-90.000000) translate(-11.500000, -10.000000) "
  }), /*#__PURE__*/React.createElement("text", {
    id: "!",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#1A1919"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.59619141,
    y: 16
  }, "!")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvviso);
export default __webpack_public_path__ + "static/media/avviso.780dcff4b3a045e946783a79efc077a4.svg";
export { ForwardRef as ReactComponent };